module.exports = __webpack_public_path__ + "static/media/loading.b7cf38a1.gif";